export default [
  {
    title: '应用ID',
    key: 'id',
    width: 30
  },
  {
    title: '授权应用名称',
    key: 'appName',
    width: 80
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 80
  },
  {
    title: '授权地址',
    key: 'authorizedAddr',
    width: 220
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: 70
  },
  {
    title: '创建人',
    key: 'createOpName',
    width: 64
  },
  {
    title: '更新人',
    key: 'upOpName',
    width: 64
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 70
  },
  {
    title: '操作',
    key: 'control',
    width: 50
  }
]
